import { useCampfireQuery } from '../../../../global/network/useCampfireQuery';
import { useUser } from '../../../../global/auth/useUser';
import { GET_JOIN_BLOCKING_TASKS } from './join-blocking-tasks.gql';
import {
  GetJoinBlockingTasks,
  GetJoinBlockingTasksVariables,
  GetJoinBlockingTasks_vm_volunteer_joinBlockingTasks as JoinBlockingTask,
} from './__generated__/GetJoinBlockingTasks';

export const JOIN_BLOCKED_MESSAGE = 'Complete your required tasks before joining';

export const useJoinBlockingTasks = () => {
  const { user, maybeVolunteerIdentity } = useUser();
  const volunteerId = maybeVolunteerIdentity?.volunteerId;
  const enabled = user.configItems?.vm?.requireTasksBeforeJoining === true && Boolean(volunteerId);

  const { data, refetch } = useCampfireQuery<GetJoinBlockingTasks, GetJoinBlockingTasksVariables>(
    GET_JOIN_BLOCKING_TASKS,
    {
      options: {
        variables: { volunteerId: volunteerId ?? '' },
        skip: !enabled,
      },
    }
  );

  const blockingTasks: JoinBlockingTask[] = enabled ? data?.vm.volunteer?.joinBlockingTasks ?? [] : [];

  return { blockingTasks, isJoinBlocked: blockingTasks.length > 0, refetch };
};
